import { render } from "./PagingIndicator.vue?vue&type=template&id=4e3ca4bc"
import script from "./PagingIndicator.vue?vue&type=script&lang=js"
export * from "./PagingIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__